export default __webpack_public_path__ + "static/ExhibitionTrailerThumbnail-c8ec7df914f0cbf9e365d2b225112cdb.jpg";